export const endpoints = (id) => ({
    HEARTBEAT: '/heartbeat-service/monitoring/heartbeat',
    LOGINURL: '/authentication-provider/oauth/authorize',
    USERINFO: '/authentication-provider/user/me',
    ACCESSTOKEN: '/authentication-provider/oauth/token',
    LOGOUT: '/authentication-provider/logout',
});